export default __webpack_public_path__ + "static/media/file-upload-usage.1eb37af2.svg";